import ModelTypeConstants from 'constants/ModelTypeConstants';
import APIUtil from 'util/APIUtil';

export default function isConfiguration(apiId: string): boolean {
  const type = APIUtil.apiIdToMaybeType(apiId);
  if (type == null) {
    return false;
  }
  if (APIUtil.isEntryOrSubOrWorkflowTemplateFileType(type)) {
    return true;
  }
  if (type === ModelTypeConstants.DOCUMENT) {
    // Prevent circular imports
    // eslint-disable-next-line global-require
    const DocumentStore = require('notebook/documents/DocumentStore').default;
    return DocumentStore.getDocument(apiId)?.isConfig ?? true; // Fallback logic duplicated in DocumentEditor
  }
  return false;
}
